import type { IconSvgObject } from './types';

const Heading06Icon: IconSvgObject = [
  ["path", { d: "M16 17C16 18.1046 16.8954 19 18 19C19.1046 19 20 18.1046 20 17C20 15.8954 19.1046 15 18 15C16.8954 15 16 15.8954 16 17ZM16 17V13C16 11.8954 16.8954 11 18 11C19.1046 11 20 11.8954 20 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 12H13M4 19V5M13 19V5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Heading06Icon;
